import { AxDropdown } from "@axess/limestone";
import { RentalPropertyDto } from "../../Dto/Rental/Properties/Result/RentalPropertyDto";

export class DropdownOption {
    constructor(label: string, value: string) {
        this.label = label;
        this.value = value;        
    }
    label: string;
    value: string;    
}

export class DropdownComponent {
    private selector: string;
    private parentId: string;
    private element: HTMLElement;
    private options: DropdownOption[];
    private allRentalProperties: RentalPropertyDto[] = [];
    private notAvailableOptions: DropdownOption[] = [];
    private labelText: string;
    private axDropdown = new AxDropdown();
    private ulElement: HTMLUListElement;
    private holder: HTMLElement;
    private mandatory: boolean = false;

    constructor(
        selector: string,
        parentId: string,
        labelText: string,
        options: DropdownOption[],
        allRentalProperties: RentalPropertyDto[],
        onSelectCallback: Function,
        mandatory: boolean = false,
    ) {
        this.selector = selector;
        this.parentId = parentId;
        this.labelText = labelText;
        this.options = options;
        this.allRentalProperties = allRentalProperties;
        this.mandatory = mandatory;
        this.render();
        this.initAxDropDown(onSelectCallback);
    }

    updateOptions(options: DropdownOption[], initialOptions: DropdownOption[] = []) {
        const notAvailableOptions: DropdownOption[] = initialOptions.filter((option) => (
            !options.some((opt) => opt.value === option.value && opt.label === option.label))
        );
        this.options = initialOptions;
        this.setInactiveOptions(this.allRentalProperties.length > 1 ? notAvailableOptions : []);
        this.updateDropdownContent();
    }

    private setInactiveOptions(notAvailableOptions: DropdownOption[]) {
        this.notAvailableOptions = notAvailableOptions;
    }

    isDuplicate(item: DropdownOption, array: DropdownOption[]): boolean {
        return array.some(existingItem =>
            existingItem.value === item.value &&
            existingItem.label === item.label
        );
    }

    getElement(): HTMLElement {
        return this.element;
    };

    resetDropDownSelection() {
        this.axDropdown.resetSelection();
    }

    setValue(value: string) {
        this.axDropdown.setValue(value);
    }

    setSelectionWithoutEvent(value: string) {
        this.axDropdown.setValue(value);
    }

    hideDropdown() {
        this.holder.style.display = 'none';
    }

    showDropdown() {
        this.holder.style.display = 'block';
    }

    private initAxDropDown(onSelectCallback: Function) {
        this.axDropdown = new AxDropdown();
        const selector = `.` + this.selector;
        this.axDropdown.init(selector,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    let value = '' + this.axDropdown.val();

                    if (value === 'select') {
                        value = null;
                    }

                    onSelectCallback(value);
                }
            });
    }

    private render() {
        this.holder = document.createElement('div');
        this.holder.classList.add('row', 'p-0', 'ax-mb-2', 'ax-pt-2');
        document.getElementById(this.parentId).appendChild(this.holder);

        const dropdown = document.createElement('div');
        dropdown.classList.add(this.selector);
        dropdown.classList.add('ax-dropdown', 'col-12');
        dropdown.setAttribute('data-mandatory-property', this.mandatory.toString());
        this.holder.appendChild(dropdown);

        const dropdownTrigger = document.createElement('a');
        dropdownTrigger.classList.add('ax-dropdown__trigger');
        dropdown.appendChild(dropdownTrigger);

        const label = document.createElement('label');
        label.classList.add('ax-dropdown__label');
        label.textContent = this.labelText;
        if (this.mandatory) {
            label.textContent += ' *';            
        }

        dropdownTrigger.appendChild(label);

        const selectionSpan = document.createElement('span');
        selectionSpan.classList.add('ax-dropdown__selection');
        dropdownTrigger.appendChild(selectionSpan);

        this.ulElement = document.createElement('ul');
        this.ulElement.classList.add('ax-dropdown__menu');
        dropdown.appendChild(this.ulElement);

        this.renderOptions(this.ulElement);

        this.element = dropdown;
    }

    private renderOptions(ul: HTMLElement) {
        this.options.forEach((option) => {
            const optionElement = document.createElement('li');
            optionElement.classList.add('ax-dropdown__item');
            optionElement.setAttribute('data-value', option.value);

            let notValid = this.notAvailableOptions.includes(option);

            if (notValid) {
                optionElement.classList.add('ax-dropdown__item--disabled');
            } else {
                optionElement.classList.remove('ax-dropdown__item--disabled');
            }

            ul.appendChild(optionElement);

            const textLeft = document.createElement('div');
            textLeft.classList.add('text-left');
            optionElement.appendChild(textLeft);

            const text = document.createElement('div');
            text.classList.add('text-body-2');
            text.textContent = option.label;
            text.innerText = option.label;
            text.innerHTML = option.label;
            textLeft.appendChild(text);
        });
    }

    private updateDropdownContent(): void {
        this.ulElement.innerHTML = '';
        this.renderOptions(this.ulElement);
    }
}

